import React from "react"
import { c, t } from "ttag"

import { CustomQuestion } from "models/CustomQuestions"
import * as Styles from "./QuestionsList.styles"

export const QuestionListRow: React.FC<QuestionListRowProps> = ({
  question,
  onEdit,
  onDelete,
}) => {
  const [ isExpanded, setIsExpanded ] = React.useState(false)

  const isUsed = question.isUsed

  return (
    <Styles.Row onClick={() => setIsExpanded(previous => !previous)}>
      <Styles.RowContent>
        <Styles.StatusCell>
          {isUsed
            ? c("Question usage wording").t`Used`
            : c("Question usage wording").t`Never used`
          }
        </Styles.StatusCell>

        <Styles.QuestionCell>
          {question.name}
        </Styles.QuestionCell>

        <Styles.ChoicesCountCell>
          {question.choices.length}
        </Styles.ChoicesCountCell>

        <Styles.ActionsCell>
          <div
            onClick={(event) => {
              event.stopPropagation()

              if (!isUsed) {
                onEdit()
              }
            }}
          >
            <Styles.ActionButton
              disabled={isUsed}
              tooltip={isUsed
                ? t`You cannot edit a question that has already been used.`
                : undefined}
            >
              {t`Edit`}
            </Styles.ActionButton>
          </div>

          <div
            onClick={(event) => {
              event.stopPropagation()

              if (!isUsed) {
                onDelete()
              }
            }}
          >
            <Styles.ActionButton
              disabled={isUsed}
              tooltip={isUsed
                ? t`You cannot delete a question that has already been used.`
                : undefined}
              destructive
            >
              {t`Delete`}
            </Styles.ActionButton>
          </div>
        </Styles.ActionsCell>
      </Styles.RowContent>

      {isExpanded && (
        <Styles.ExpandedContent>
          <Styles.ChoicesList>
            {question.choices.map((choice, index) => (
              <Styles.Choice key={choice.id}>
                <Styles.ChoiceIndex>
                  {index + 1}
                </Styles.ChoiceIndex>

                <Styles.ChoiceName>
                  {choice.name}
                </Styles.ChoiceName>
              </Styles.Choice>
            ))}
          </Styles.ChoicesList>
        </Styles.ExpandedContent>
      )}
    </Styles.Row>
  )
}

export interface QuestionListRowProps {
  question: CustomQuestion,
  onEdit: () => void,
  onDelete: () => void,
}
